import { detectKeyboardUser } from '@/features/shared/utils/detectKeyboardUser'
import { medallia } from '@/lib/medallia'
import { appSemVersion, appVersion } from '@shared/constants/build'

export const initApp = () => {
  const releaseAppVersion = appVersion && `(${appVersion})`
  const formattedVersion = appSemVersion ? `${appSemVersion} ${releaseAppVersion}` : appVersion

  import('ua-parser-js').then((mod) => {
    const { name: browserName, version: browserVersion } = new mod.default().getBrowser()
    // special case: output the troubleshooting info
    // oxlint-disable-next-line no-console
    console.log(
      `%c
      ATTENTION!
  
      This is to be used for troubleshooting only if a Shipt team member specifically asks for the app version.
      Shipt will NEVER ask for your password or anything other than the browser info below when opening this console.
  
      App Version: ${formattedVersion}
      Browser: ${browserName}
      Browser Version: ${browserVersion}
    `,
      'color: #038767',
    )
  })
  import('@/lib/env').then((mod) => mod.checkEnvVariables())

  detectKeyboardUser()
  medallia.setParams()
}
